import { z } from 'zod';
import { expectType, RolesEnum, zDocument } from './model.js';
import { reverseKeys } from './util/reverseKeys.js';
export const VolumeOptions = {
    low: 'Low',
    medium: 'Medium',
    high: 'High'
};
export const EnemiesThresholdOptions = {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    off: 'Disabled'
};
export const VolumeOptionsEnum = z.nativeEnum(reverseKeys(VolumeOptions));
export const EnemiesThresholdOptionsEnum = z.nativeEnum(reverseKeys(EnemiesThresholdOptions));
const FeedPreferencesFields = z.object({
    fireHose: z.boolean(),
    volumePreference: VolumeOptionsEnum,
    preferFriends: z.boolean(),
    preferFriendsOfFriends: z.boolean(),
    enemiesThreshold: EnemiesThresholdOptionsEnum,
    preferPopular: z.boolean()
});
export const zTopicPreferences = z.object({
    following: z.array(z.string()),
    hidden: z.array(z.string())
});
expectType({});
expectType({});
export const EngagementLevels = ['none', 'medium', 'high'];
export const DefaultEngagementLevel = 'none';
export const EngagementLevelPreferences = {
    none: {
        postLike: false,
        postRead: false,
        commentLike: false
    },
    medium: {
        postLike: true,
        postRead: false,
        commentLike: true
    },
    high: {
        postLike: true,
        postRead: true,
        commentLike: true
    }
};
export const zNotificationPreferences = z.object({
    email: z.boolean()
});
expectType({});
expectType({});
export const zUser = zDocument.extend({
    type: z.literal('user'),
    email: z.string(),
    username: z.string(),
    password: z.string(),
    description: z.string(),
    roles: z.array(RolesEnum),
    salt: z.string(),
    registrationToken: z.string(),
    active: z.boolean(),
    profileImage: z.string(),
    feedPreferences: FeedPreferencesFields,
    topicPreferences: zTopicPreferences,
    notificationPreferences: zNotificationPreferences,
    suspendedUntil: z.string().datetime().or(z.literal('')),
    termsOfServiceVersion: z.number(),
    termsOfServiceAcceptedDate: z.string().datetime().or(z.literal('')),
    experienceFlags: z.array(z.string()),
    engagementLevel: z.enum(EngagementLevels),
    subscriptionEndDate: z.string()
});
expectType({});
expectType({});
export const zFullAuthorFields = z.object({
    fullAuthor: zUser
});
expectType({});
expectType({});
export const DefaultFeedPreferences = {
    fireHose: false,
    volumePreference: 'medium',
    preferFriends: true,
    preferFriendsOfFriends: true,
    preferPopular: true,
    enemiesThreshold: 'medium'
};
export const DefaultTopicPreferences = {
    hidden: [],
    following: []
};
export const DefaultNotificationPreferences = {
    email: true
};
export const EmptyNewUser = {
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    type: 'user',
    email: '',
    password: '',
    description: '',
    roles: [],
    salt: '',
    registrationToken: '',
    active: false,
    username: '',
    profileImage: '',
    suspendedUntil: '',
    feedPreferences: DefaultFeedPreferences,
    topicPreferences: DefaultTopicPreferences,
    notificationPreferences: DefaultNotificationPreferences,
    termsOfServiceVersion: 0,
    termsOfServiceAcceptedDate: '',
    experienceFlags: [],
    engagementLevel: DefaultEngagementLevel,
    subscriptionEndDate: ''
};
export const AnonymousUser = { ...EmptyNewUser, username: 'anonymous', roles: ['anonymous'] };
export const EmptyUser = EmptyNewUser;
export const zAuthorFields = z.object({
    author: z.string()
});
// Validate zod schema matches
expectType({});
expectType({});
expectType({});
expectType({});
export function isFullAuthor(item) {
    return 'fullAuthor' in item;
}
